<div class="tab-pane" role="tabpanel" id="arquitecto">
    <fieldset id="agregar_arquitecto" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de los Arquitectos(<span
                        style="color:red; font-size: 25px">*</span>)</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar arquitectos</p>
                    <div class="form-horizontal">
                        <div class="form-group">
      
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <form [formGroup]="rut_arq">
                                    <mat-form-field class="example-full-width" style="width: 100%">
                                        <input matInput placeholder="Rut" id="rut_arq" name="rut_arq"
                                            formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_arq && rut_arq.controls?.rut.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                        <mat-error *ngIf="rut_arq && rut_arq.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 text-left">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_arq"
                                    [disabled]="!rut_arq.valid" (click)="get_arquitecto(rut_arq.controls.rut.value)">
                                    Agregar Arquitecto
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4"></div>
                        </div>
                    </div>

                    <!--Detalle de los arquitectos-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span>
                                        {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>ARQUITECTOS</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_arquitecto(row.rut,rowIndex)" style="padding-right: 5px;"><i
                                            class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_arquitecto(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->

    <!--Material Modal Dialog-->
    <ng-template #openModal>
        
        <mat-dialog-content class="text-center">
            <h2 mat-dialog-title>Ingresar informaci&oacute;n del Arquitecto</h2>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del arquitecto</strong>, su solicitud pasar&aacute; <br>por un
                    proceso de verificaci&oacute;n del arquitecto ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%"> 
                            
                            <input matInput id="rut" name="rut" type="text" placeholder="RUT (*)" class=""
                            [(ngModel)]="arquitecto.rut" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="nombre" name="nombre" type="text" placeholder="Nombre o Raz&oacute;n Social (*)"
                            class="" [(ngModel)]="arquitecto.nombre">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div id="hide-pat-enterprise">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="apellido_pat" name="apellido_pat" type="text" placeholder="Apellido Paterno (*)"
                                class="" [(ngModel)]="arquitecto.apellido_pat">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="apellido_mat" name="apellido_mat" type="text" placeholder="Apellido Materno (*)"
                                class="" [(ngModel)]="arquitecto.apellido_mat">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        
                        <div class="col-md-3"></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="direccion" name="direccion" type="text" placeholder="Calle"
                                class="" [(ngModel)]="arquitecto.direccion">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3"></div>
                        <div class="col-md-3">
                            <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="dir_num_arquitect" name="direccion_num" type="text" placeholder="Numero"
                                class="" [(ngModel)]="arquitecto.direccion_num">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width">
                                <input matInput type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput
                                    [formControl]="nombreComuna" [matAutocomplete]="auto" placeholder="Comuna"
                                    [(ngModel)]="arquitecto.comuna">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="fono" name="fono" type="text" placeholder="Tel&eacute;fono"
                                class="" [(ngModel)]="arquitecto.fono">
                            </mat-form-field>
                        </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="fax" name="fax" type="text" placeholder="fax" class=""
                                [(ngModel)]="arquitecto.fax">
                            </mat-form-field>
                        </div>
                    <div class="col-md-2"></div>
                </div>

                <form [formGroup]="mail_arq">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field style="width: 100%;" floatLabel="never">
                                <input matInput type="email" placeholder="Email (*)" id="email_propiet" name="email_propiet"
                                    formControlName="mail" [(ngModel)]="arquitecto.mail" class="">
                                <mat-error *ngIf="mail_arq.controls.mail.errors?.required">Email requerido
                                </mat-error>
                                <mat-error *ngIf="mail_arq.controls.mail.errors?.pattern">Formato incorrecto.
                                    Ej:
                                    correo@servidor.dominio. </mat-error>
                                <mat-error *ngIf="mail_arq.controls.mail.errors?.maxlength">Excede el máximo de
                                    caracteres
                                    (50). </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </form>
                <!-- <div class="form-group">
                    <label class="col-md-4 control-label" for="mail">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="mail" name="mail" type="email" placeholder="mail@ejemplo.com" class="form-control input-md" [(ngModel)]="arquitecto.mail">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="patente" name="patente" type="text" placeholder="Patente (*)"
                            class="" [(ngModel)]="arquitecto.patente">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="profesion" name="profesion" type="text" placeholder="Profesi&oacute;n"
                            class="" [(ngModel)]="arquitecto.profesion">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <div class="form-horizontal">
            <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <p style="text-align: center;">
                    <strong
                        *ngIf="!arquitecto.rut || !arquitecto.nombre || !arquitecto.apellido_pat || !arquitecto.apellido_mat || !arquitecto.mail || !arquitecto.patente">
                        Faltan campos obligatoriosCampos obligatorios(<span style="color: red">*</span>)</strong>
                    </p>
                </div>
                <div class="col-md-1"></div>
            </div>

            <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10 text-center">
                    <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_arquitecto" data-dismiss="modal"
                        (click)="cleanData()">Cancelar</button>
                
                    <button mat-raised-button color="primary" id=" ingreso_arquitect" (click)="saveArquitecto() "
                        [disabled]="!arquitecto.rut || !arquitecto.nombre || !arquitecto.apellido_pat || !arquitecto.apellido_mat || !arquitecto.mail || !arquitecto.patente || mail_arq.status == 'INVALID' ">Ingresar
                        Arquitecto <i class="fa fa-user-o " aria-hidden="true "></i></button>
                </div>
                <div class="col-md-1"></div>
            </div>
            </div>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>
<div class="separator"></div>